// Trigger frontend deployment pipeline - run 2
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from "./Utils/APIutils/msalConfig";
import { AuthProvider } from './Context/CustomContext';
import { FiltersProvider } from './Context/FiltersContext';
import { GatewayContagemProvider } from './Context/GatewayContagemContext';
import { AlertProvider } from './Context/AlertContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const msalInstance = new PublicClientApplication(msalConfig);

// initialize() must complete before rendering so MSAL can detect a popup
// redirect in progress and close the popup before React renders anything.
msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <HelmetProvider>
          <FiltersProvider>
            <AuthProvider instance={msalInstance}>
              <GatewayContagemProvider>
                <AlertProvider>
                  <App />
                </AlertProvider>
              </GatewayContagemProvider>
            </AuthProvider>
          </FiltersProvider>
        </HelmetProvider>
      </MsalProvider>
    </React.StrictMode>
  );
});
